import styled from '@emotion/styled';

const HeaderPlayer = styled('div')(({ theme }) => ({
  marginBottom: theme.dimensions.pageGutter,
}));

export default HeaderPlayer;
